import { render, staticRenderFns } from "./SelectTeacher.vue?vue&type=template&id=056cd341&scoped=true"
import script from "./SelectTeacher.vue?vue&type=script&lang=js"
export * from "./SelectTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cd341",
  null
  
)

export default component.exports